<div *ngIf="environment.qa" class="absolute top-0 right-0 p-10 px-20 m-10 rounded-full shadow-lg bg-gray-lighter">
  <mat-slide-toggle [(ngModel)]="showLocalSimon" (change)="openSimonSso()">Local Simon</mat-slide-toggle>
</div>
<iframe class="w-full h-full" [appIframeData] [src]="iframeUrl | safeUrl"></iframe>